<!-- 工作台 -->
<template>
    <div id="fee">
            <el-table
                    :data="dataList"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="RName"
                        label="车主昵称">
                </el-table-column>
                <el-table-column
                        prop="RCarNum"
                        label="车牌号"
                        width="100">
                </el-table-column>
                <el-table-column
                        width="110"
                        prop="RPhone"
                        label="电话号码">
                </el-table-column>
                <el-table-column
                        prop="RAddr"
                        label="地址">
                </el-table-column>
                <el-table-column
                        prop="Operator"
                        label="创建人">
                </el-table-column>
                <el-table-column
                        label="服务类型">
                    <template slot-scope="scope">
                        {{scope.row.RType|RTypeHandle}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="SurplusMoney"
                        label="待付金额(元)">
                </el-table-column>
                <el-table-column
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="sendFeeFrom(scope.row)">发送</el-button>
                    </template>
                </el-table-column>
            </el-table>
    </div>
</template>
<script>
    export default {
        name: "fee",
        components: {

        },
        props: {
            uid: String
        },
        data() {
            return {
                dataList:[]
            };
        },
        filters: {
            RTypeHandle(value){
                return value == 1 ? '上门检修':'公路救援'
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            sendFeeFrom(data){
                data.RName = data.RType == 1?"上门维修费用单":"公路救援费用单"
                this.$store.commit('updateRepairFeeMsg',data)
                this.$emit('closeFee')
            },
            getData(){
                this.axios.get('/RepairManagement/GetClientToBeConfimRR',{
                    params: {
                        cid:this.uid
                    }
                }).then((response)=> {
                        let data = response.data.data
                        this.dataList = data
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
        }
    };
</script>
<style lang="less" scoped>

</style>

